import { client } from "helpers/client";

export interface Price {
  priceBeforeDiscount: number;
  discountPercentage: number;
  netPrice: number;
  currencySymbol: string;
  discrimination: string;
}

interface Version {
  id: number;
  price: Price;
  modules: AddonModule[];
  addons: AddonModule[];
  downloadCount:number;
}

export interface AddonModule {
  id: number;
  title: string;
  logo: string;
}

interface Tag {
  id: number;
  name: string;
  isActive: boolean;
}

export interface Rate {
  averageRate: number;
  count: number;
  stars: {
    star: 1 | 2 | 3 | 4 | 5;
    percentage: number;
  }[];
}

export interface Label {
  name:string, color:string
}

export interface RelatedApp {
  isWishListed:boolean
  id: number;
  title: string;
  logo: {
    fullPath: string;
  };
  featuredTag: string;
  hasLabel: boolean;
  label: Label | null;
  rate: number;
  reviewersCount: number;
  price: Price | null;
}

export interface App {
  title: string;
isInWishlist:boolean,
  logo: any;
  description: string;
  rate?: Rate;
  reviewersCount: number;
  label?: any | null;
  slidersPath: string[];
  tags: Tag[];
  relatedApps: RelatedApp[];
}
export interface AvailabeFeatures {
  id: number;
  title: string;
  moreDetail: string;
}
interface Versions {
  id: number;
  applicationId: number;
  name: string;
  logo: any;
  isHighlightedVersion: boolean;
  price:Price | null;
  availabeFeatures: AvailabeFeatures[]
}

export class AppDetailService {
  static getAppDetail(id: number) {
    return client<App>(`/apps/${id}`);
  }

  static getVersionDetail(appId: number, versionId?: number) {
    return client<Version>(`/apps/version/${appId}/${versionId ?? ""}`);
  }
  static getPricingAndPlans(appId: number) {
    return client<Versions>(`/Apps/AppDetailsPricingAndPlans/${appId}`);
  }
  static getAvailableVersionsByApp(appId: number, priceLevelId?: number) {
    return client<Version>(`/apps/GetAvailableVersionsByApplication/${appId}/${priceLevelId ?? ""}`);
  }
}
